import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgReceive = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.4992 22H4.50087C3.90719 22 3.42957 21.5224 3.42957 20.9287V19.8574C3.42957 19.2637 3.90719 18.7861 4.50087 18.7861H19.4992C20.0929 18.7861 20.5705 19.2637 20.5705 19.8574V20.9287C20.5705 21.5224 20.0929 22 19.4992 22ZM7.46483 9.0751L10.3931 12.0033V3.07131C10.3931 2.47763 10.8707 2 11.4644 2H12.5357C13.1294 2 13.607 2.47763 13.607 3.07131L13.607 12.0033L16.5352 9.0751C16.9548 8.65551 17.6333 8.65551 18.0485 9.0751L18.8073 9.83395C19.2269 10.2535 19.2269 10.932 18.8073 11.3472L12.7589 17.4001C12.3393 17.8197 11.6608 17.8197 11.2457 17.4001L5.19276 11.3516C4.77317 10.932 4.77317 10.2535 5.19276 9.83841L5.9516 9.07957C6.3712 8.65997 7.0497 8.65997 7.46483 9.0751Z", fill: props.fill }));
});
export default SvgReceive;
